/**
 */

/**
 * @enum {string}
 */
export default {
  /**
   * @type {string}
   */
  BOOLEAN: 'boolean',
  /**
   * @type {string}
   */
  DATE: 'date',
  /**
   * @type {string}
   */
  DATETIME: 'datetime',
  /**
   * @type {string}
   */
  TIME: 'time',
  /**
   * @type {string}
   */
  GEOMETRY: 'geometry',
  /**
   * @type {string}
   */
  NUMBER: 'number',
  /**
   * @type {string}
   */
  SELECT: 'select',
  /**
   * @type {string}
   */
  TEXT: 'text'
};
